const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJjIconFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.4 8.6a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0zm1.499.8a3.201 3.201 0 0 1-6.198 0H4.8V7.8h12.9a3.201 3.201 0 0 1 6.199 0h3.3v1.6H23.9zM5.599 15h-.8v1.6h3.302a3.201 3.201 0 0 0 6.198 0h12.9V15H14.3a3.201 3.201 0 0 0-6.198 0H5.6zm0 7.2h-.8v1.6H17.702a3.201 3.201 0 0 0 6.198 0h3.3v-1.6H23.9a3.201 3.201 0 0 0-6.198 0H5.6zm15.2 2.4a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2zm-8-8.8a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0z",
    clipRule: "evenodd",
    style: {
      fill: "#eb1600"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJjIconFilter);
export default __webpack_public_path__ + "static/media/JJ_Icon_Filter.01ba5389ffc62375856a128107d179d0.svg";
export { ForwardRef as ReactComponent };